import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
export class PreviewAreaComponent extends React.Component {
    constructor(props) {
        super(props);
        this._onPointerOverCanvas = () => {
            this.props.globalState.pointerOverCanvas = true;
        };
        this._onPointerOutCanvas = () => {
            this.props.globalState.pointerOverCanvas = false;
        };
        this.state = { isLoading: true };
        this._leftRef = React.createRef();
        this._rightRef = React.createRef();
        this._onIsLoadingChangedObserver = this.props.globalState.onIsLoadingChanged.add((state) => {
            this.setState({ isLoading: state });
        });
        this._onResetRequiredObserver = this.props.globalState.onResetRequiredObservable.add(() => {
            this.forceUpdate();
        });
        props.globalState.updateState = (left, right) => {
            if (this._leftRef.current) {
                this._leftRef.current.innerHTML = left;
            }
            if (this._rightRef.current) {
                this._rightRef.current.innerHTML = right;
            }
        };
    }
    componentWillUnmount() {
        this.props.globalState.onIsLoadingChanged.remove(this._onIsLoadingChangedObserver);
        this.props.globalState.onResetRequiredObservable.remove(this._onResetRequiredObserver);
    }
    componentDidMount() {
        this.props.onMounted?.();
    }
    render() {
        return (_jsxs(_Fragment, { children: [_jsxs("div", { id: "preview", children: [_jsx("canvas", { onPointerOver: this._onPointerOverCanvas, onPointerOut: this._onPointerOutCanvas, id: "preview-canvas" }), _jsx("div", { className: "waitPanel" + (this.state.isLoading ? "" : " hidden"), children: "Please wait, loading..." })] }), _jsxs("div", { id: "preview-config-bar", children: [_jsx("div", { className: "left", ref: this._leftRef }), _jsx("div", { className: "right", ref: this._rightRef })] })] }));
    }
}
//# sourceMappingURL=previewAreaComponent.js.map